
export default function WhyEntertainment() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-[900px] mx-auto px-6 lg:px-12 text-center">
        <h2 className="text-4xl lg:text-5xl font-bold text-black mb-10 leading-tight">
          ENTERTAINMENT DESIGN?
        </h2>
        
        <div className="space-y-3 text-gray-700 leading-relaxed text-lg">
          <p>
            モノの時代から、コトの時代へ。
          </p>
          <p>
            あらゆる接点にエンターテイメントを。
          </p>
          <p>
            私たちは「売る」ではなく、<br />
            「関係をつくる」体験をデザインする。
          </p>
          <p className="pt-4">
            購買ではなく、"発見"<br />
            機能ではなく、"共感"<br />
            取引ではなく、"愛着"
          </p>
          <p className="pt-4">
            気づけばまた触れたくなる。
          </p>
          <p className="font-semibold pt-2">
            それが、私たちの考える<br className="lg:hidden" />
            エンターテイメントデザイン
          </p>
        </div>
      </div>
    </section>
  );
}
